import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  input: {
    textOverflow: 'ellipsis'
  },
  attribute: {
    minWidth: theme.spacing(35),
    paddingRight: theme.spacing(3),
    fontWeight: 'bold',
    fontSize: 14,
  },
  titleTypography: {
    fontWeight: 'bold',
    marginRight: 4,
    flex: 1
  },
  valueField: {
    flex: 1
  },
  margin: {
    margin: theme.spacing(1),
  },
  box: {
    maxHeight: '30px',
    minHeight: '30px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  button: {
    padding: '0.3rem 1rem',
    fontSize: '12px',
  },
  buttonMargin: {
    margin: '0 12px',
  },
  textBox: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    height: 30,
  },
  autocomplete: {
    height: 50,
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
  },
  select: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    textOverflow: 'ellipsis',
    height: 30,
  },
  unSelected: {
    color: theme.palette.grey[500],
  },
  checkbox: {
    height: 10,
  },
}));

export default useStyles;
